module.exports = __webpack_public_path__ + "static/media/mt.4f20d5a7.svg";